// Import the polyfill function first
import { ensurePixiLoaded } from "./polyfill";

console.log("Script started - initializing game");

// Wrap the initialization in a function to ensure proper execution order
async function initGame() {
  try {
    // First, ensure Pixi.js is properly loaded
    console.log("Pre-loading Pixi.js...");
    await ensurePixiLoaded();

    // Only import Pixi after ensuring it's loaded
    const { Application } = await import("pixi.js");
    const { Game } = await import("./game/Game");

    console.log("Starting app initialization");

    // Create a Pixi application
    const app = new Application();

    // Wait for the application to initialize
    await app.init({
      background: "#000000",
      resizeTo: window,
      antialias: true,
    });
    console.log("App initialization complete");

    // Add the canvas to the HTML document
    const gameContainer = document.getElementById("game-container");
    console.log("Game container:", gameContainer);

    // Remove the loading message when ready
    const loadingMessage = document.querySelector(".loading-message");
    if (loadingMessage && loadingMessage.parentNode) {
      loadingMessage.parentNode.removeChild(loadingMessage);
    }

    if (gameContainer) {
      gameContainer.appendChild(app.canvas);
      console.log("Canvas appended to container");
    } else {
      console.error("Could not find game-container element");
    }

    // Create and start the game
    console.log("Creating game instance");
    const game = new Game(app);
    console.log("Game instance created");

    // Connect TouchControls to the Game instance
    // This allows TouchControls to directly start the game
    if (game.touchControls) {
      game.touchControls.setGameReference(game);
      console.log("TouchControls connected to Game instance");
    }

    // Add a direct touch handler for iOS
    document.addEventListener(
      "touchstart",
      function () {
        // Try to directly start the game on first touch (iOS specific)
        if (game) {
          console.log("Document touchstart - attempting direct game start");
          game.directStartGame();
        }
      },
      { once: true, passive: true },
    );

    // Handle window resize
    window.addEventListener("resize", () => {
      console.log("Window resized to:", {
        width: app.screen.width,
        height: app.screen.height,
      });
    });

    // Export game instance for debugging purposes
    (window as any).game = game;
    console.log("Game initialization complete");
  } catch (error) {
    console.error("Error during initialization:", error);
  }
}

// Start the game initialization
initGame().catch((err) => {
  console.error("Fatal error during game initialization:", err);
});
